module.exports = __webpack_public_path__ + "img/main-banner-bg.eeed007.jpg";